import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class Errormessage {
  msg: HttpErrorResponse;
}
@Injectable()
export class ErrorService {
  error = new BehaviorSubject<Errormessage>(null);
  constructor() { }

  showErrorMessage(msg: string, url: string) {

  }

}
